module.exports = __webpack_public_path__ + "fonts/fs_lola-medium-webfont.9b391830.woff";